<template>
  <div class="confirmation-data-item">
    <div class="confirmation-data-item_name">{{ name }}</div>
    <div class="confirmation-data-item_value">{{ filteredValue }}</div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationDataItem",
  props: {
    name: String,
    value: String,
    filter: String,
  },
  computed: {
    filteredValue() {
      if (this.filter) {
        return this.$options.filters[this.filter](this.value);
      }
      return this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.confirmation-data-item {
  font-size: 18px;
  margin-bottom: 20px;

  .confirmation-data-item_name,
  .confirmation-data-item_value {
    width: 60%;
    display: inline-block;
    vertical-align: top;
  }

  .confirmation-data-item_name {
    width: 40%;
  }

  .confirmation-data-item_name {
    font-weight: bold;
    color: $color_stephs-grey;
  }

  .confirmation-data-item_value {
    color: $color_does-this-make-you-feel-special;
    word-break: break-all;

    @media (max-width: $grid-breakpoint-md) {
      text-align: right;
    }
  }
}
</style>
